const currencyMap = {
  USD: (value: number): string => `$${value}`,
};

export const currency = (
  value: number,
  symbol: keyof typeof currencyMap = 'USD',
): string => currencyMap[symbol](value);
